import { ca } from '@cian/analytics';

export function trackBannerClick() {
  ca('eventSite', {
    action: 'click',
    category: 'promo_rent_gift',
    label: 'listing_banner_promo_rent_gift',
    name: 'oldevent',
    page: {
      extra: {
        trap_type: 'listing_banner_promo_rent_gift',
      },
    },
  });
}

export function trackBannerShow() {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'promo_rent_gift',
    label: 'listing_banner_promo_rent_gift',
    name: 'oldevent',
    page: {
      extra: {
        trap_type: 'listing_banner_promo_rent_gift',
      },
    },
  });
}
